'use client';
import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import {getMessage, isGeneralAdmissionSection} from './utils';

import '../styles/index.scss';

const ReactSeatInfo = ({products, showInfo, isInformed, quantity}) => {
  const isGASection = isGeneralAdmissionSection(products);
  const message = getMessage(products, quantity, isInformed);

  if (!showInfo || isGASection) {
    return null;
  }

  return message ? (
    <div className="SeatInfo__container" data-testid="seat-info-message">
      {message}
    </div>
  ) : null;
};

ReactSeatInfo.propTypes = {
  /**
   * An array of product objects to be processed.
   */
  products: PropTypes.array,

  /**
   * The number of products to be displayed.
   */
  quantity: PropTypes.number.isRequired,

  /**
   * A flag indicating whether the user has been informed about something.
   */
  isInformed: PropTypes.bool,

  /**
   * A flag indicating whether to show seats info.
   */
  showInfo: PropTypes.bool,
};

export default injectIntl(ReactSeatInfo);
